/**
 * USER -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the user module
 */
// eslint-disable-next-line
export const USER = {
  CREATE: 'users/create' as 'users/create',
  UPDATE: 'users/update' as 'users/update',
  DELETE: 'users/delete' as 'users/delete',
  FIND_USER: 'users/findUser' as 'users/findUser',
  FIND_ALL: 'users/findAll' as 'users/findAll',
}
